import { useIsShowRequestSampleCode } from '@/business-components/request-sample-code/hooks/useIsShowRequestSampleCode';
import { useResponseParameterValue } from '@/business-components/response-parameter/hooks/useResponseParameterValue';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import { ApiDocLayout } from '@/shared/constant/layout/ApiDocLayout';
import React from 'react';

export function useIsShowRightSampleCode(value: HttpApiServerType) {
  const { responses } = useResponseParameterValue(value);
  const isShowRequestSampleCode = useIsShowRequestSampleCode();
  const apiDocLayout = useDocsDataModelStore((x) => x.docsBaseConfig.apiDocLayout);
  const responseExamples = React.useMemo(() => {
    return (responses?.map((x) => x.responseExamples) ?? []).flat().filter(Boolean);
  }, [responses]);

  if (apiDocLayout !== ApiDocLayout.TwoColumn) {
    return false;
  }
  if (!isShowRequestSampleCode && !responseExamples?.length) {
    return false;
  }

  return true;
}
